import PropTypes from 'prop-types';
import { TextField as MuiTextField, Box } from '@mui/material';
import { alertIcon } from './resources';

const TextField = ({
  variant = "outlined",
  margin = "normal",
  inputLabelProps = {},
  inputProps = {},
  alert = false,
  wrapperStyles = {},
  children = null,
  ...rest
}) => {
  return (
    <Box sx={{
      width: '100%',
      position: 'relative',
      ...wrapperStyles, 
    }}>
      <MuiTextField
        margin={margin}
        variant={variant}
        InputLabelProps={{
          sx: {
            fontSize: '1.4rem !important',
            ...inputLabelProps?.sx,
          },
          ...inputLabelProps,
        }}
        InputProps={{
          sx: {
            '& textarea': {
              overflowY: 'auto', // IE vertical scroll fix
            },
            ...inputProps?.sx,
          },
          endAdornment: alert && <img src={alertIcon} alt="Alert Icon" />,
          ...inputProps,
        }}
        {...rest}
      >
        {children}
      </MuiTextField>
    </Box>
  );
};

TextField.propTypes = {
  ...MuiTextField.propTypes,
  alert: PropTypes.bool,
  wrapperStyles: PropTypes.object
};

export default TextField;